import axios from "axios"
import library from "../../../utils/Library"

export const initializeAppInstanceMERegistration = async (organization) => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("miestudio_user_registration") +
    "/initializeAppInstanceMERegistration"

  return await axios({
    url: URL,
    method: "POST",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
    data: organization,
  })
}
